import React from 'react';
import DatePicker from 'react-datepicker';
import { connect as connectFormik } from 'formik';
import Moment from 'moment';

const IntegrationNextImportInternal = props => {
  const { formik } = props;
  const { values, setFieldValue } = formik;
  const { NextImportAt } = values;

  const defaultDate = NextImportAt ? new Date(NextImportAt) : new Date();
  return (
    <DatePicker
      key='NextImportAt'
      name='NextImportAt'
      style={{ width: '320px', display: 'inline-block' }}
      selected={defaultDate}
      onChange={date => setFieldValue('NextImportAt', Moment(date).format())}
      showTimeSelect
      timeFormat='HH:mm'
      timeIntervals={1}
      timeCaption='time'
      dateFormat='MMMM d, yyyy h:mm aa'
    />
  );
};

export const IntegrationNextImport = connectFormik(
  IntegrationNextImportInternal
);